module.exports = __webpack_public_path__ + "img/imageGalery8.3e41c94a.jpeg";